import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  onClick,
  type = 'button',
  className = '',
  disabled = false
}: ButtonProps) {
  const baseStyles = 'font-semibold rounded-md transition-all duration-200 inline-flex items-center justify-center';
  const variantStyles = {
    primary: 'bg-[#E63946] text-white hover:bg-[#D32F2F] shadow-md hover:shadow-lg',
    secondary: 'bg-[#0B1F3A] text-white hover:bg-[#162D4A] shadow-md hover:shadow-lg',
    outline: 'border-2 border-white text-white hover:bg-white hover:text-[#0B1F3A]'
  };
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';
  return <button type={type} onClick={onClick} disabled={disabled} className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${className}`} data-id="element-350">
      {children}
    </button>;
}